const Inspector = ({ inspector }) => {
  if (!inspector) {
    return '-';
  }

  return [inspector.name, inspector.surname, inspector.email].join(' ');
};

export default Inspector;
